export const fetchENSAddressForDomain = (name, provider) => provider === null || provider === void 0 ? void 0 : provider.resolveName(name);
